import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import AutocompleteGeolocation from "../Map/AutocompleteGeolocation";
import Map from "../Map/Map";
import { Box } from "@mui/material";
import useStyles from "./formStyles";

const LocationRenderer = ({
  name,
  onChange,
  value,
  disabled,
  label,
  error = "",
  isReadOnly = false,
}) => {
  const styles = useStyles();
  const [location, setLocation] = useState(value);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (value) {
      setLocation(value);
    }
  }, [value]);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 200); // Delay render after Drawer mount
    return () => clearTimeout(timer);
  }, []);

  const handleLocationChange = (newLocation) => {
    setLocation(newLocation);
    onChange({ target: { name, value: newLocation } });
  };

  return (
    <Box className="form-control">
      {!isReadOnly && visible ? (
        <AutocompleteGeolocation
          address={location?.address}
          name={name}
          onChange={handleLocationChange}
          label={label}
          error={error}
          styles={styles}
          disabled={disabled}
        />
      ) : null}
      {visible ? (
        <Map
          label={isReadOnly ? label : null}
          lat={location?.lat}
          lng={location?.lng}
          onLocationChange={handleLocationChange}
          isReadOnly={isReadOnly}
        />
      ) : null}
    </Box>
  );
};

LocationRenderer.propTypes = {};

export default LocationRenderer;
